import ForgotPasswordScreen from "./component/forgotPassword";
function Login() {
  return <ForgotPasswordScreen />;
}

export default Login;
